import { render, staticRenderFns } from "./save-items-btn.vue?vue&type=template&id=1b2c931a&"
import script from "./save-items-btn.vue?vue&type=script&lang=js&"
export * from "./save-items-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports